import React, { Fragment } from 'react';
import '../css/chart-modal.less';

export default ({columns, header, closeModal, className}) => {
    const renderTable = () => {
        let headers = (<tr key='tr-headers'>{
            columns.map((column, index) => <th key={`th-${index}`}>{column.displayName}</th>)
        }</tr>);
        let rows = [headers];

        for(let i=0;i<columns[0].values.length;i++){
            let tds = [];
            columns.forEach((column,index)=>{
                let td = (
                    <td key={`td-${index}`}>
                        {
                            (index === 0 || !(column.values[i].constructor === Array)) ? column.values[i] :
                            <Fragment>
                                <span className='td-value'>{column.values[i][0]}</span>
                                <div className='chart-line'></div>
                                <span className='td-value'>{column.values[i][1]}</span>
                            </Fragment>
                        }
                    </td>
                )
                tds.push(td);
            })
            let tr = (<tr key={`tr-${i}`}>{tds}</tr>);
            rows.push(tr);
        }
        return rows;
    }

    return(
            <div className='chart-content'>
                <p className='section-title'>{header}</p>
                <table className='content-table'>
                    <tbody>
                        {
                            renderTable()
                        }
                    </tbody>
                </table>
            </div>
    )
}
